// Zeigt während der Umstiegsfrist die Wahl zwischen sofortiger Einrichtung und Überspringen.
import React from "react";
import { Button, LinearProgress, Typography } from "@material-ui/core";

const formatDeadline = (value) => {
	const deadline = new Date(value);
	if (Number.isNaN(deadline.getTime())) return value;
	return new Intl.DateTimeFormat("de-AT", {
		dateStyle: "long",
		timeStyle: "short"
	}).format(deadline);
};

const MfaOptionalPrompt = ({ deadline, processing, error, onEnroll, onSkip }) => <>
	<Typography component="h1" variant="h5" align="center">
		Zwei-Faktor-Anmeldung einrichten
	</Typography>
	<Typography paragraph>
		Schütze dein Konto schon jetzt mit einem zusätzlichen sechsstelligen Authenticator-Code.
	</Typography>
	<Typography paragraph>
		Die Einrichtung wird ab {formatDeadline(deadline)} verpflichtend. Bis dahin kannst du diesen Schritt überspringen.
	</Typography>
	{error && <Typography color="error">Die Einrichtung konnte nicht gestartet werden.</Typography>}
	<Button
		variant="contained"
		color="primary"
		fullWidth
		disabled={processing}
		onClick={onEnroll}
	>
		Jetzt einrichten
	</Button>
	<Button fullWidth disabled={processing} onClick={onSkip}>
		Vorerst überspringen
	</Button>
	{processing && <LinearProgress color="secondary" />}
</>;

export default MfaOptionalPrompt;
